import { useRef, useState } from "react";
import { Tag } from "antd";

export const EmailTagInput = ({ value, onChange, disabled, placeholder }) => {
  const [inputVal, setInputVal] = useState("");
  const inputRef = useRef(null);

  const tags = Array.isArray(value)
    ? value
    : typeof value === "string" && value
      ? value
          .split(",")
          .map((e) => e.trim())
          .filter(Boolean)
      : [];

  const addTag = (raw) => {
    const emails = raw
      .split(",")
      .map((e) => e.trim())
      .filter(Boolean);
    const unique = emails.filter((e) => !tags.includes(e));
    if (unique.length) onChange?.([...tags, ...unique].join(","));
    setInputVal("");
  };

  const removeTag = (email) => {
    onChange?.(tags.filter((t) => t !== email).join(","));
  };

  const handleKeyDown = (e) => {
    if (["Enter", ",", " ", "Tab"].includes(e.key)) {
      e.preventDefault();
      if (inputVal.trim()) addTag(inputVal);
    } else if (e.key === "Backspace" && !inputVal && tags.length) {
      removeTag(tags[tags.length - 1]);
    }
  };

  return (
    <div
      onClick={() => !disabled && inputRef.current?.focus()}
      style={{
        display: "flex",
        flexWrap: "wrap",
        gap: 4,
        alignItems: "center",
        minHeight: 32,
        padding: "4px 8px",
        border: "1px solid #d9d9d9",
        borderRadius: 6,
        cursor: disabled ? "not-allowed" : "text",
        background: disabled ? "#f5f5f5" : "#fff",
      }}
    >
      {tags.map((email) => (
        <Tag
          key={email}
          closable={!disabled}
          onClose={() => removeTag(email)}
          style={{ margin: 0, fontSize: 13 }}
        >
          {email}
        </Tag>
      ))}
      {!disabled && (
        <input
          ref={inputRef}
          value={inputVal}
          onChange={(e) => setInputVal(e.target.value)}
          onKeyDown={handleKeyDown}
          onBlur={() => {
            if (inputVal.trim()) addTag(inputVal);
          }}
          placeholder={tags.length === 0 ? placeholder : ""}
          style={{
            border: "none",
            outline: "none",
            flex: 1,
            minWidth: 120,
            fontSize: 14,
            background: "transparent",
            padding: "2px 0",
          }}
        />
      )}
    </div>
  );
};
